var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('popup',{directives:[{name:"show",rawName:"v-show",value:(_vm.popupNameStatus),expression:"popupNameStatus"}],ref:"popup",attrs:{"activeKey":_vm.activeKey ? _vm.activeKey : '3'}}),_vm._v(" "),_c('keep-alive',{attrs:{"include":"MyStatistics"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ec5237","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 